<div
  class="google-map-wrapper"
  [style.height]="mapHeight"
  [style.minHeight]="minHeight">
  <div class="google-map" #googleMap></div>
</div>
